<template>
  <div class="d-flex ">
    <!-- 第一層選單 begin -->
    <div class="te-nav d-flex flex-column ">
      <div class="image-panel image-panel-1 bg-none mx-auto d-flex" @click="goHome()">
        <a href="javascript:void(0)" class="image-panel image-panel-n2 rounded-circle" title="回首頁">
          <img src="@/assets/images/favicon-96x96.png" alt="" class="w-100">
        </a>
      </div>
      <div>
        <b-button
          v-for="item in PrimaryMenu"
          :key="item.id"
          variant="primary"
          size="sm"

          :class="{'current':item.current,
                   'active':selectedPrimary===item.id}"
          @click="PrimaryNavigate(item)"
        >
          <span class="material-icons md-18">{{ item.icon }}</span>
          <span
            class="font-size-sm"
          >{{ (item.id || '') !== '' ? $t(`features.${item.id}`) : '' }}</span>
        </b-button>
      </div>
      <!--
      <div>
        <b-button variant="primary" size="sm" class="w-100 py-3">
          <span class="material-icons-outlined">info</span>
          <span class="font-size-sm">關於</span>
        </b-button>
      </div>
      -->
    </div>
    <!-- 第一層選單 end -->
    <!-- 第二層選單 begin -->
    <!-- 點關閉時改成NavFadeOutLeft -->
    <div
      v-if="showSecondaryMenu"
      class="te-nav-secondary d-flex flex-column"
      :class="[showSecondaryMenu ? 'NavFadeInLeft' : 'NavFadeOutLeft']"
    >
      <div class="d-flex">
        <a href="javascript:void(0)" class="te-logo" title="回首頁" @click="goHome()">
          <img src="@/assets/images/logo_telexpress_w.svg" class="w-75" alt="">
        </a>
        <!-- 關閉按鈕 begin -->
        <a href="javascript:void(0)" class="bg-none image-panel image-panel-1" @click="closeSecondaryMenu()">
          <span class="material-icons text-white">keyboard_double_arrow_left</span>
        </a>
        <!-- 關閉按鈕 end -->
      </div>
      <PerfectScrollbar>
        <div
          v-for="item in SecondaryMenu"
          :key="item.id"
        >
          <b-button
            variant="primary"
            size=""
            class="te-nav-btn-sec "
            :class="{'current':item.open||item.current}"
            :pressed="item.open"
            @click="SecondaryNavigate(item)"
          >
            <span class="flex-grow-1">
              {{ $t(`features.${item.id}`) }}
            </span>
            <span v-if="item.children.length" class="material-icons md-18">{{ (item.open?'expand_less':'expand_more') }}</span>
          </b-button>
          <b-collapse :id="item.id" v-model="item.open" class="te-nav-third" visible>
            <b-button v-for="tertiary in getSelectedTeriaryFeatures(selectedPrimary,item.id)" :key="tertiary.id" variant="primary te-nav-btn-third" :class="{'current':tertiary.current}" @click="TertiaryNaviagte(tertiary)">
              <div class="te-nav-third-dot" /><span>{{ $t(`features.${tertiary.id}`) }}</span>
            </b-button>
          </b-collapse>
        </div>
      </PerfectScrollbar>
      <!-- 關閉按鈕 begin -->
      <!-- <b-button variant="primary" size="" class="close-nav" @click="selectedPrimary = ''">
        <span class="material-icons md-18">chevron_left</span>
      </b-button> -->
      <!-- 關閉按鈕 end -->
    </div>
    <!-- {{ TertiaryFeatures }} -->
    <!-- 第二層選單 end -->
    <slot />
  </div>
</template>

<script>
// import Vue from 'vue';
import VueRouter from 'vue-router';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { mapGetters } from 'vuex';
import * as AuthorizationService from '@/services/AuthorizationService';

const { isNavigationFailure } = VueRouter;

export default {
  components: {
    PerfectScrollbar
  },
  data() {
    return {
      displaySecondary: false,
      features: [],
      selectedPrimary: '',
    };
  },
  computed: {
    ...mapGetters(['getSelectedTeriaryFeatures']),
    company() {
      return this.$store.getters.company;
    },
    PrimaryMenu() {
      return this.$store.getters.primaryFeatures;
    },
    showSecondaryMenu() {
      return this.SecondaryMenu.length > 0;
    },
    SecondaryMenu() {
      if ((this.selectedPrimary || '') === '') return [];

      const secondaryFeatures = this.$store.getters.getSecondaryFeatures(this.selectedPrimary);

      return secondaryFeatures;
    },
    TertiaryFeatures() {
      return this.$store.getters.getCurrentTeriaryFeatures();
    },
  },
  watch: {
    company() {
      this.LoadFeaturesAsync();
    },
  },
  created() {
    this.LoadFeaturesAsync();
  },
  methods: {
    async LoadFeaturesAsync() {
      await this.$loading(async () => {
        await AuthorizationService.LoadEnabledFeaturesAsync();
      });
    },
    routerPush(navigate) {
      const n = { ...navigate };
      if (navigate.name === this.$router.history.current.name || navigate.name === 'CloudShopManagementSetting') {
        n.query = n.query || {};
        n.query.t = +new Date();
      }
      this.$router.push(n).catch((failure) => {
        if (!isNavigationFailure(failure)) {
          Promise.reject(failure);
        }
      });
    },
    PrimaryNavigate(route) {
      if (route.Navigate && !route.current) {
        this.closeSecondaryMenu();
        this.routerPush(route.Navigate);
      } else {
        this.selectedPrimary = route.id;
      }
    },
    SecondaryNavigate(route) {
      if (route.children.length > 0) {
        this.SecondaryArrow(route);
      } else {
        this.routerPush(route.Navigate || { name: 'FeatureNotFound' });
      }
    },
    TertiaryNaviagte(route) {
      this.routerPush(route.Navigate || { name: 'FeatureNotFound' });
    },
    closeSecondaryMenu() {
      this.selectedPrimary = '';
    },
    SecondaryArrow(route) {
      this.$store.commit('setSecondaryOpen', { id: route.id, open: !route.open });
    },
    goHome() {
      this.selectedPrimary = '';
      this.$router.push({ name: 'FeatureIndex' });
    }
  }
};
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
